export default __webpack_public_path__ + "static/media/050-badge.83770e76.png";